import { NavLink } from "react-router-dom";

function Leistung() {
    return <main className="leistung content-box">
        <p>Ich begleite Filmprojekte von der ersten Idee bis zum finalen Ergebnis. Jeder Schritt im Prozess verdient Aufmerksamkeit und Präzision, um ein überzeugendes Ergebnis zu schaffen. So entfaltet deine Idee ihr volles Potential.</p>
        <div className="card-container">
            <div className="card">
                <div className="card-img vision"><h1>Planung</h1></div>
                <p>Ob ganzheitliches Marketingkonzept oder purer, künstlerischer Ausdruck: mit unserem Bild schlagen wir die Brücke zwischen Inhalten und Zuschauern.</p>
                <p>Mit erprobter Methodik planen wir Dein Projekt und starten zuversichtlich in die Dreharbeiten.</p>
            </div>
            <div className="card">
                <div className="card-img dreh"><h1>Dreh</h1></div>
                <p>Am Set entsteht die visuelle Sprache deines Films – authentisch, atmosphärisch und auf den Punkt inszeniert.</p>
                <p>Mit einfühlsamer Regie, technischer Expertise und einem genauem Auge schaffen wir gemeinsam bewegende Aufnahmen.</p>
            </div>
            <div className="card">
                <div className="card-img editing"><h1>Editing</h1></div>
                <p>Das richtige Tempo, hochwertiges CGI, professionelles Color Grading und immersiver Sound runden das Erlebnis ab.</p>
                <p>Plattformoptimiert und gut abgestimmt begeistert dein Film in jeder Umgebung.</p>
            </div>
        </div>
        <div className="cta">
            <span>Bereit für den ersten Schritt?</span>
            <NavLink className="button" to="/kontakt">Lass uns dein Projekt planen!</NavLink>
        </div>
    </main >
}

export default Leistung;